export default [
    // *===================Bank List============================---*
    {
        path: '/bank',
            name: 'bank',
            component: () => import('@/views/accounting/bank/Bank.vue'),
            meta: {
                pageTitle: 'Bank',
                breadcrumb: [
                    {
                        text: 'Bank',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    }
    ]